import axios from "axios";
import { takeLatest, put } from "redux-saga/effects";

import { API_BASE_URI } from "../ApiCall";
import { ContractMeetingActionTypes } from "./ContractMeeting.type";

export function* fetchAllContractMeetings(action: any): any {
  try {
    const response = yield axios.get(
      `${API_BASE_URI}/contract-meeting?project_id=${action.payload?.project_id}`
    );
    yield put({
      type: ContractMeetingActionTypes.FETCH_ALL_CONTRACT_MEETING_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: ContractMeetingActionTypes.FETCH_ALL_CONTRACT_MEETING_FAILURE,
      payload: error,
    });
  }
}

export function* fetchOneContractMeetings(action: any): any {
  try {
    const response = yield axios.get(
      `${API_BASE_URI}/contract-meeting/${action.payload}`
    );
    yield put({
      type: ContractMeetingActionTypes.FETCH_ONE_CONTRACT_MEETING_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: ContractMeetingActionTypes.FETCH_ONE_CONTRACT_MEETING_FAILURE,
      payload: error,
    });
  }
}

export function* watcherFetchAllContractMeetings() {
  yield takeLatest(ContractMeetingActionTypes.FETCH_ALL_CONTRACT_MEETING, fetchAllContractMeetings);
}

export function* watcherFetchOneContractMeetings() {
  yield takeLatest(ContractMeetingActionTypes.FETCH_ONE_CONTRACT_MEETING, fetchOneContractMeetings);
}
